export enum ChatActions {
  EDIT = 'Edit',
  DELETE = 'Delete',
  RESPOND = 'Direct Message'
}
